import React from 'react';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import QueryKeys from '@/utils/QueryKeys';
import { plato_api_scores_data_path } from '@/modules/routes';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import BulkGradingWrapper from '@/components/shared/Grading/Navigation/BulkGrading';
import { ScoreData } from '@/components/shared/Grading/Navigation/BulkGrading/types';
import { IAssignment } from '@/components/staffer/Grading/types';

const getKey = (assignment: IAssignment) => {
  const { assignment_details: { exercise_type: exerciseType } } = assignment;

  const formattedType = exerciseType.match(/[A-Z][a-z]+/g).join('_');

  return `${formattedType}_id`.toLowerCase();
};

const BulkGradingButton = () => {
  const lessonId = new URLSearchParams(window.location.search).get('lesson_id');
  if (lessonId == null) return null;

  const assignment = useGradingStore(state => state.assignment);
  const classroom = useGradingStore(state => state.classroom);
  const questionId = useGradingStore(state => state.questionId);

  const { data: scoresData, isFetching } = useQuery({
    enabled: !!(questionId || classroom || assignment),
    placeholderData: [],
    queryFn: () => (
      axios
        .get<{ data: ScoreData[] }>(plato_api_scores_data_path({
          assignment_id: assignment.id,
          classroom_id: classroom.id,
          lesson_id: lessonId,
          question_id: questionId,
          [getKey(assignment)]: assignment.assignment_details.exercise_id,
        }))
        .then(res => res.data.data)
    ),
    queryKey: [QueryKeys.ScoresData, questionId, classroom?.id, assignment?.id],
  });

  if (scoresData.length === 0) return null;
  if (scoresData[0].questionAutoGraded || scoresData[0].promptOnly) return null;

  return <BulkGradingWrapper disabled={isFetching} scoresData={scoresData} />;
};

export default BulkGradingButton;
